/** @jsx jsx */
import { Box, Button, EmptyState, EmptyStateSadSquare, EmptyStateSadSquareWhite } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DialogDisclosure, useDialogState } from "reakit/Dialog";
import { jsx } from "theme-ui";

import { TimeReport } from "@/data/time-reports";

import { TimeReportProjectModal } from "../projects";

interface TimeReportCalendarEmptyStateProps {
  timeReport: TimeReport;
  editable?: boolean;
}

export const TimeReportCalendarEmptyState: FC<TimeReportCalendarEmptyStateProps> = ({ timeReport, editable }) => {
  const { t } = useTranslation("session");

  const projectModalState = useDialogState({ animated: true });

  return (
    <Box sx={{ py: 120 }} px="sm">
      <EmptyState
        icon={editable ? <EmptyStateSadSquare /> : <EmptyStateSadSquareWhite />}
        title={t("TIME_REPORTS.CALENDAR.EMPTY_HEADER")}
        content={
          editable ? t("TIME_REPORTS.CALENDAR.EMPTY_MESSAGE_EDITABLE") : t("TIME_REPORTS.CALENDAR.EMPTY_MESSAGE")
        }
        action={
          editable ? (
            <Button as={DialogDisclosure} {...projectModalState}>
              {t("TIME_REPORTS.CALENDAR.ADD_NEW_PROJECT")}
            </Button>
          ) : null
        }
      />
      <TimeReportProjectModal dialogState={projectModalState} timeReport={timeReport} />
    </Box>
  );
};
